import { Button } from '@accure/ui';
import { useBoolean } from 'usehooks-ts';

import {
  Dialog,
  DialogActions,
  type DialogProps,
} from '@/components/ui/dialog';
import { cls } from '@/utils/cls';

export type ConfirmDialogProps = {
  submitText: string;
  onSubmit: () => Promise<void>;
} & Omit<DialogProps, 'onSubmit'>;

export function ConfirmDialog({
  children,
  submitText,
  onSubmit,
  onClose,
  className,
  ...props
}: ConfirmDialogProps) {
  const isLoading = useBoolean(false);

  async function handleSubmit() {
    isLoading.setTrue();
    try {
      await onSubmit();
    } finally {
      isLoading.setFalse();
    }
  }

  return (
    <Dialog onClose={onClose} {...props} className={cls('mt-24', className)}>
      {children}
      <DialogActions>
        <Button variant="ghost" onClick={() => onClose(true)}>
          Cancel
        </Button>
        <Button
          variant="destructive"
          onClick={handleSubmit}
          disabled={isLoading.value}
        >
          {submitText}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
